import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { childSendI } from '@interfaces/child/child'
import { fcUserCatalogItem } from '@interfaces/fc-user/fc-user'


export const newChildRecordSlice = createSlice({
    name: 'new-child-record',
    initialState: {
        id: '',
        weightForSize: null,
        battelleResult: null,
        addEDIResult: null,
        typeApplication: '',
        result: null,
        username: '',
        performedByUser: "",
        modifiedByUser: ""
    } as childSendI,
    reducers: {
        setChildRecord: (state, action: PayloadAction<childSendI>) => {
            state.id = action.payload.id
            state.weightForSize = action.payload.weightForSize
            state.battelleResult = action.payload.battelleResult  
            state.addEDIResult = action.payload.addEDIResult 
            state.typeApplication = action.payload.typeApplication 
            state.result = action.payload.result 
            state.username = action.payload.username
            state.performedByUser = action.payload.performedByUser 
            state.modifiedByUser = action.payload.modifiedByUser
        },
        setChildRecordId: (state, action: PayloadAction<string>) => {
            state.id = action.payload
        },
        setChildRecordButForSize: (state, action: PayloadAction<fcUserCatalogItem>) => {
            state.weightForSize = action.payload
        },
        setChildRecordBattelleResult: (state, action: PayloadAction<fcUserCatalogItem>) => {
            state.battelleResult = action.payload
        },
        setChildRecordAddEDIresults: (state, action: PayloadAction<boolean | null>) => {
            state.addEDIResult = action.payload
        },
        setChildRecordTypeApplication: (state, action: PayloadAction<string>) => {
            state.typeApplication = action.payload
        },
        setChildRecordResult: (state, action: PayloadAction<fcUserCatalogItem>) => {
            state.result = action.payload
        },
        cleanChildRecord: (state) => { 
            state.id = ''
            state.weightForSize = null
            state.battelleResult = null
            state.addEDIResult = null
            state.typeApplication = ''
            state.result = null
        },
    },
})

export const { 
    setChildRecord,
    setChildRecordId,
    setChildRecordButForSize,
    setChildRecordBattelleResult,
    setChildRecordAddEDIresults,
    setChildRecordTypeApplication,
    setChildRecordResult,
    cleanChildRecord
    } = newChildRecordSlice.actions
export default newChildRecordSlice.reducer
